import type { TransactionChannelType } from '../types/transaction.types';
import type { PaymentMethod } from '../types/transaction.types';

/**
 * Maps each PaymentMethod to the fee-scale channel type used when looking up
 * applicable technology fees.
 *
 * 'card' resolves to 'credit' as the default card fee scale. Debit card
 * distinction is handled post-MVP via the POST /fragments/fees endpoint.
 */
export const PAYMENT_METHOD_CHANNEL_TYPE: Readonly<Record<PaymentMethod, TransactionChannelType>> =
  Object.freeze({
    card: 'credit',
    ach: 'ach',
  });

/**
 * Reverse of PAYMENT_METHOD_CHANNEL_TYPE: maps a channel type from
 * allowedTransactionTypes back to the PaymentMethod that uses it.
 */
export const CHANNEL_TYPE_PAYMENT_METHOD: ReadonlyMap<string, PaymentMethod> = new Map(
  (Object.entries(PAYMENT_METHOD_CHANNEL_TYPE) as [PaymentMethod, TransactionChannelType][]).map(
    ([paymentMethod, channelType]) => [channelType, paymentMethod],
  ),
);
